import { call, put, takeLatest } from 'redux-saga/effects';
import {
    updateProfileStart,
    updateProfileSuccess,
    updateProfileFailure,
    loadPhoneProfileStart,
    loadPhoneProfileSuccess,
    loadPhoneProfileFailure,
    updateProfileRequest,
    loadPhoneProfileRequest
} from '../whatsappProfileSlice';
import { updateWhatsappProfileApi, getPhoneProfileApi } from '../../api/apiLists/whatsappProfileApi';
import { callWithAuth } from '../sagaApiHelper';
import { showAlert } from '../alertSlice';
import { uploadFileToS3 } from './fileUploadHelper';

function* handleUpdateProfile(action) {
    try {
        const { payload } = action;

        yield put(updateProfileStart());

        let profileUpdatePayload = { ...payload };
        let imageUrl = null;

        if (profileUpdatePayload.profileImageFile) {
            try {
                const file = profileUpdatePayload.profileImageFile;
                const companyId = profileUpdatePayload.companyId;

                imageUrl = yield call(uploadFileToS3, file, companyId, 'waba-phone-profile-pic');
            } catch (fileError) {
                const errorMsg = fileError?.message || 'Failed to upload profile image. Please try again.';
                yield put(updateProfileFailure(errorMsg));
                yield put(showAlert({
                    message: errorMsg,
                    type: 'error'
                }));
                return;
            }

            delete profileUpdatePayload.profileImageFile;
            if (imageUrl) {
                profileUpdatePayload.imageUrl = imageUrl;
            }
        }

        const res = yield call(callWithAuth, updateWhatsappProfileApi, profileUpdatePayload);

        if (res.status && res.data) {
            const {
                companyId,
                phoneNumberId,
                ...updatableFields
            } = profileUpdatePayload;

            yield put(updateProfileSuccess({
                ...res.data,
                ...updatableFields
            }));
            yield put(showAlert({
                message: res.msg || 'Profile updated successfully',
                type: 'success'
            }));
        } else {
            yield put(updateProfileFailure(res.errMsg || 'Failed to update profile'));
            yield put(showAlert({
                message: res.errMsg || 'Failed to update profile',
                type: 'error'
            }));
        }
    } catch (error) {
        const errorMessage = error.message || 'An unexpected error occurred';
        yield put(updateProfileFailure(errorMessage));
        yield put(showAlert({
            message: errorMessage,
            type: 'error'
        }));
    }
}

function* handleLoadPhoneProfile(action) {
    try {
        const { payload } = action;

        yield put(loadPhoneProfileStart());

        const res = yield call(callWithAuth, getPhoneProfileApi, payload);

        if (res.status && res.data) {
            yield put(loadPhoneProfileSuccess(res.data));
        } else {
            yield put(loadPhoneProfileFailure(res.errMsg || 'Failed to load phone profile'));
        }
    } catch (error) {
        const errorMessage = error.message || 'An error occurred while loading phone profile';
        yield put(loadPhoneProfileFailure(errorMessage));
    }
}

export default function* whatsappProfileSaga() {
    yield takeLatest(updateProfileRequest.type, handleUpdateProfile);
    yield takeLatest(loadPhoneProfileRequest.type, handleLoadPhoneProfile);
}